<bevvi-bot-chat-card [type]="type.MESSAGE" [description]="payload().text" />
